/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClosePdmDeliveryEncodedRequest } from '../models/ClosePdmDeliveryEncodedRequest';
import type { ClosePdmDeliveryRequest } from '../models/ClosePdmDeliveryRequest';
import type { ClosePdmDeliveryResponse200 } from '../models/ClosePdmDeliveryResponse200';
import type { ClosePdmDeliveryResponse207 } from '../models/ClosePdmDeliveryResponse207';
import { request as __request } from '../core/request';

export class PdmService {

    /**
     * Close one or more deliveries via PDM (Partial Delivery Management)
     * Closes deliveries in the PDM flow. Only deliveries with status PARTIAL (5) or IN_USE (2) that have at least one record in DELIVERY_VARIANCE are eligible. IN_USE deliveries without variance records are not eligible (use MNDL instead). EPCs with IN_TRANSIT status are moved to the user-selected destination status. STOLEN is not allowed as a destination status. On close, a confirmation is written to ZMIM_STORE_CONF with FLOW_TYPE=PDM. No stock movements are generated (QTY, MOVE_TYPE, MOVE_REAS, UPC are null). DELIVERY_VARIANCE records are deleted for closing deliveries.
     *
     * @returns ClosePdmDeliveryResponse200 PDM close delivery operation successful without any failed deliveries.
     * @returns ClosePdmDeliveryResponse207 Multi-Status. Response contains both closed deliveries and deliveries that could not be closed.
     * @throws ApiError
     */
    public static async receiveshipClosePdmDelivery({
        requestBody,
    }: {
        requestBody: ClosePdmDeliveryRequest,
    }): Promise<ClosePdmDeliveryResponse200 | ClosePdmDeliveryResponse207> {
        const result = await __request({
            method: 'PUT',
            path: `/receiveship/closePdmDelivery`,
            body: requestBody,
            errors: {
                400: `Bad request. Invalid input or delivery in NEW status (use MNDL instead).`,
                401: `Authorization information is missing or invalid.`,
                403: `Forbidden. User lacks MANAGE_DELIVERY privilege.`,
                409: `Conflict. Delivery is STOLEN or already CONFIRMED.`,
                500: `Unexpected error.`,
            },
        });
        return result.body;
    }

    /**
     * Close one or more deliveries via PDM (encoded version for handheld scanners)
     * Base64-encoded version of the closePdmDelivery endpoint for handheld scanner devices. The decoded payload must conform to the ClosePdmDeliveryRequest schema.
     *
     * @returns ClosePdmDeliveryResponse200 PDM close delivery operation successful
     * @returns ClosePdmDeliveryResponse207 Multi-Status. Response contains both closed deliveries and deliveries that could not be closed.
     * @throws ApiError
     */
    public static async receiveshipClosePdmDeliveryEncoded({
        requestBody,
    }: {
        requestBody: ClosePdmDeliveryEncodedRequest,
    }): Promise<ClosePdmDeliveryResponse200 | ClosePdmDeliveryResponse207> {
        const result = await __request({
            method: 'PUT',
            path: `/receiveship/closePdmDeliveryEncoded`,
            body: requestBody,
            errors: {
                400: `Bad request. Invalid input or delivery in NEW status.`,
                401: `Authorization information is missing or invalid.`,
                403: `Forbidden. User lacks MANAGE_DELIVERY privilege.`,
                409: `Conflict. Delivery is STOLEN or already CONFIRMED.`,
                500: `Unexpected error.`,
            },
        });
        return result.body;
    }

}